//Bootstrap
import { Dropdown, Tab } from 'bootstrap';

// Customs
import SmoothScroll from './components/SmoothScroll';
import Responsive from './components/Responsive';
import BurgerMenu from './components/BurgerMenu';
import Utils from './components/Utils';
import Slider from './components/Slider';
import Form from './components/Form';
import GeneralAnimations from './components/GeneralAnimations';
import CustomSelect from './components/CustomSelect';
import Tabs from './components/Tabs';
import UnBlur from './components/UnBlur';
import Map from './components/Map';
import Ajax from './components/Ajax';

document.addEventListener('DOMContentLoaded', function (event) {
  const responsive = new Responsive(992);
  const pageScroller = new SmoothScroll(responsive);
  const cSelect = new CustomSelect(pageScroller);

  Utils.init(pageScroller, responsive);
  GeneralAnimations.init(pageScroller, responsive)
  BurgerMenu.init(pageScroller);
  Form.init();
  Tabs.init();
  Slider.init();
  UnBlur.init();
  Map.init();
  Ajax.init(cSelect, pageScroller);
});
